import { NetConfig } from "./NetConfig/NetConfig";

export const netConfig = new NetConfig();
export type { SupportedChainNetworks } from "./NetConfig/NetConfig";
export { NetConfig };
